import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: '',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
      keepAlive: false,
    },
    component: () => import('@/views/home.vue'),
  },
  {
    path: '/TCM',
    name: 'TCM',
    meta: {
      title: '云课堂-中医类别课程',
      keepAlive: false,
    },
    component: () => import('@/views/TCMinfo.vue'),
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: '联系我们',
      keepAlive: false,
    },
    component: () => import('@/views/about.vue'),
  },
  {
    path: '/classExam',
    name: 'classExam',
    meta: {
      title: '联系我们',
      keepAlive: false,
    },
    component: () => import('@/views/classExam.vue'),
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      title: '隐私协议',
      keepAlive: false,
    },
    component: () => import('@/views/agreement.vue'),
  },
  {
    path: '/list1',
    name: 'list1',
    meta: {
      title: '',
      keepAlive: false,
    },
    component: () => import('@/views/list1.vue'),
  },
  {
    path: '/list2',
    name: 'list2',
    meta: {
      title: '',
      keepAlive: false,
    },
    component: () => import('@/views/list2.vue'),
  },
  {
    path: '/seachlist',
    name: 'seachlist',
    meta: {
      title: '',
      keepAlive: false,
    },
    component: () => import('@/views/seachlist.vue'),
  },
  {
    path: '/videolist',
    name: 'videolist',
    meta: {
      title: '',
      keepAlive: false,
    },
    component: () => import('@/views/videolist.vue'),
  },
  {
    path: '/personal',
    name: 'personal',
    meta: {
      title: '',
      keepAlive: false,
    },
    component: () => import('@/views/personal/index.vue'),
    children: [
      {
        // 当 /user/:id/profile 匹配成功，
        // UserProfile 会被渲染在 User 的 <router-view> 中
        path: 'personal',
        name: 'lpersonal',
        component: () => import('@/views/personal/personal.vue'),
      },
      {
        // 当 /user/:id/posts 匹配成功
        // UserPosts 会被渲染在 User 的 <router-view> 中
        path: 'history',
        name: 'history',
        component: () => import('@/views/personal/history.vue'),
      },
      {
        // 当 /user/:id/posts 匹配成功
        // UserPosts 会被渲染在 User 的 <router-view> 中
        path: 'collection',
        name: 'collection',
        component: () => import('@/views/personal/collection.vue'),
      },
      {
        // 当 /user/:id/posts 匹配成功
        // UserPosts 会被渲染在 User 的 <router-view> 中
        path: 'myExam',
        name: 'myExam',
        component: () => import('@/views/personal/myExam.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      keepAlive: false,
    },
    component: () => import('@/views/login.vue'),
  },
];
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
const router = new VueRouter({
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    // vue2.0  x  y  控制
    // vue3.0  left  top 控制
    return { left: 0, top: 0 };
  },
});
router.beforeEach((to, from, next) => {
  // if (to.meta && to.meta.title) {
  // 	document.title = to.meta.title;
  // }
  // console.log(to.query)
  // if(to.query.hospital_id){
  // 	localStorage.setItem('hospital_id',to.query.hospital_id)
  // }
  window.scrollTo(0, 0);
  const token = localStorage.getItem('token');
  if (!token && to.path == '/videolist') {
    store.dispatch('user/changeDialog', { isshow: true, type: 1 });
    return;
  }

  if (to.path != '/list1' && to.path != '/list2' && to.path != '/videolist' && to.path != '/classExam') {
    localStorage.removeItem('navList');
  }
  if (from.name && from.path != '/classExam' && (to.path == '/list1' || to.path == '/list2')) {
    let navList = JSON.parse(localStorage.getItem('navList')) || [];
    if ((from.path == '/list2' || from.path == '/videolist') && to.path == '/list1') {
      navList = navList.slice(0, 1);
    } else if (from.path == '/videolist' && to.path == '/list2') {
      navList = navList.slice(0, 2);
    } else {
      navList.push({ name: to.query.fromName, to: { path: from.fullPath } });
    }
    localStorage.setItem('navList', JSON.stringify(navList));
  }
  next();
});

export default router;
